import { useMemo } from "react";
import { SingleKindSelectFileDialog } from "./SingleKindSelectFileDialog.js";
const useResolvedSingleKindFileSelection = ({ fileSelectionComponent, fileSelectionProps }, connectorFactoryFactory) => {
  return useMemo(() => {
    return getResolvedSingleKindFileSelection({ fileSelectionComponent, fileSelectionProps }, connectorFactoryFactory);
  }, [connectorFactoryFactory, fileSelectionComponent, fileSelectionProps]);
};
const getResolvedSingleKindFileSelection = ({ fileSelectionComponent, fileSelectionProps }, connectorFactoryFactory) => {
  if (!fileSelectionComponent) {
    return void 0;
  }
  const dialogProps = {
    innerComponent: fileSelectionComponent,
    innerProps: fileSelectionProps,
    connectorFactory: connectorFactoryFactory()
  };
  return {
    dialogComponent: SingleKindSelectFileDialog,
    dialogProps
  };
};
export {
  getResolvedSingleKindFileSelection,
  useResolvedSingleKindFileSelection
};
//# sourceMappingURL=useResolvedSingleKindFileSelection.js.map
